var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowstar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 24.0212L22.5938 22.1887L25.4531 31.5L15.75 24.0212ZM31.5 11.9858H19.4531L15.75 0L12.0469 11.9858H0L9.75001 19.4151L6.04687 31.4009L15.7969 23.9717L21.7969 19.4151L31.5 11.9858Z",
    fill: "#FDD405"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowstar);
export default __webpack_public_path__ + "static/media/yellowstar.290992dd7bf8500238231943038f3fe5.svg";
export { ForwardRef as ReactComponent };